export enum Identification {
    DriversLicense = 1,
    InternationalPassport = 2,
    NationalIdCard = 3,
    VotersCard = 4,
    CompanyRegistrationNumber = 5,
    CompanyTaxIndentificationNumber = 6
}
